import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Tarea',
  alias: ['/sistema/crm/Tarea/Index'],
  documento: 'crm',
  filas: ['138'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/TareaController.cs',
  redirecciones: [
    {
      desde: '/sistema/crm/Tarea/MyTasks',
      a: '/sistema/crm/Tarea?myTasks=true',
      codigo: 302,
      cita: 'prod:Areas/CRM/Controllers/TareaController.cs:MyTasks',
    },
  ],
} satisfies RutaProd & { redirecciones: { desde: string; a: string; codigo: 302; cita: string }[] };
